import { CloneActionsDropdownContainer } from './CloneActionsDropdownContainer';
import { CloneActionsDropdownContent } from './CloneActionsDropdownContent';
import type { CloneActionsDropdownProps } from './types';

export const ClonePageActionsDropdown = (props: CloneActionsDropdownProps) => {
  return (
    <CloneActionsDropdownContainer
      {...props}
      dropdownContent={CloneActionsDropdownContent}
    />
  );
};
